"use client";

import Image from "next/image";
import Link from "next/link";
import { COMPANY } from "../lib/site";

/**
 * SiteFooter — colophon mark.
 *
 * The single rule-line band at the very base of every page: small-caps
 * navigation on the left, dateline on the right, copyright below.
 * No marketing copy — a colophon is for facts only.
 */
export default function SiteFooter() {
  const now = new Date();
  // Format like a real journal indicia: ISSN-style edition.
  const dateline = now
    .toLocaleDateString("en-AU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .toUpperCase();

  return (
    <footer
      style={{
        // Transparent so the page-wide Spline backdrop shows through.
        background: "transparent",
        padding: "32px clamp(20px, 4vw, 56px) 40px",
        borderTop: "1px solid var(--fg)",
      }}
    >
      <div style={{ maxWidth: "1240px", margin: "0 auto" }}>
        {/* Row 1: nav links left, dateline right */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "20px",
            paddingBottom: "20px",
            borderBottom: "1px solid var(--border-strong)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "20px", flexWrap: "wrap" }}>
            <Image
              src="/dux-logo-glass.webp"
              alt="Dux AI"
              width={800}
              height={394}
              sizes="64px"
              style={{ height: "30px", width: "auto" }}
            />
            <Link href="/privacy" className="footer-link">
              Privacy
            </Link>
          </div>
          <span
            style={{
              fontSize: "10px",
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: "var(--fg-3)",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            Vol. 01 · {dateline}
          </span>
        </div>

        {/* Row 2: legal indicia */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "12px",
            marginTop: "20px",
            fontSize: "11px",
            color: "var(--fg-3)",
            letterSpacing: "0.02em",
          }}
        >
          <span>
            © {now.getFullYear()} {COMPANY.legalName}
          </span>
          <span style={{ letterSpacing: "0.12em", textTransform: "uppercase" }}>
            Made in Australia · Since 1915
          </span>
        </div>
      </div>
    </footer>
  );
}
